import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { Store } from '@ngrx/store';
import * as AuthActions from './store/auth.actions';
import { Router } from '@angular/router';
import { AuthState, getAuthState } from './store/auth.reducer';
import { Observable } from 'rxjs';

import { locale as English } from './i18n/en';
import { locale as French } from './i18n/fr';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class LoginComponent implements OnInit {

    loginForm: FormGroup;
    loading$: Observable<boolean>;
    loggedIn$: Observable<boolean>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private translateLoaderService: FuseTranslationLoaderService,
        private _formBuilder: FormBuilder,
        private _store: Store<AuthState>,
        private _router: Router
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };

        this.translateLoaderService.loadTranslations(English, French);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.loginForm = this._formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
        });

        this.redirectToHome();

    }

    onSubmit() {
        this._store.dispatch(new AuthActions.DoLoginAction({ username: this.loginForm.value.username, password: this.loginForm.value.password }));
        this.redirectToHome();
    }

    private redirectToHome() {
        this._store.select(getAuthState).subscribe(authState => {
            if (!authState.loading && authState.loggedIn) {
                this._router.navigate(['']);
            }
        });
    }
}
